module.exports = __webpack_public_path__ + "img/python.7bb13fc4.svg";